import React, { useContext, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { connectSideNav } from 'shared/hoc/withSideNav';
import connectRoutes from 'shared/hoc/withRoutes';
import { couponCreateCheck, couponViewCheck } from 'features/coupon/api/coupons';
import { FilterContext, prepareFilters } from 'shared/hoc/withFilters';
import { processRoutes } from 'shared/utils';
import { MODULES } from 'shared/constants';
import { createPath, rootPath, viewPath } from 'shared/routes/coupon';
import CouponGetter from './CouponGetter';
import CouponSearch from './CouponSearch';
import CouponCreator from './CouponCreator';

const withSideNav = connectSideNav(MODULES.coupon);

const withFilters = prepareFilters(MODULES.coupon);

const withRoutes = connectRoutes([
  {
    RouteComponent: CouponGetter,
    path: `${viewPath}/:couponId`,
    routeToTest: couponViewCheck,
  },
  {
    RouteComponent: CouponSearch,
    path: viewPath,
    text: 'View Coupons',
    routeToTest: couponViewCheck,
    key: 'view_coupons',
  },
  {
    RouteComponent: CouponCreator,
    path: createPath,
    text: 'Create Coupons',
    routeToTest: couponCreateCheck,
  },
]);

/**
 * @param {Object} props
 * @param {Array<Object>} props.enabledRoutes
 */
function Coupon(props) {
  const { enabledRoutes } = props;
  const {
    savedFilters,
    getFavoriteFilters,
  } = useContext(FilterContext);

  useEffect(() => {
    if (!savedFilters) {
      getFavoriteFilters();
    }
  }, [savedFilters, getFavoriteFilters]);

  const initialCouponNavRoutes = [];
  const initialStaticRoutes = [];

  const { staticRoutes } = processRoutes(
    enabledRoutes,
    initialStaticRoutes,
    initialCouponNavRoutes,
    savedFilters,
  );

  return (
    <Switch>
      {staticRoutes.map((route) => (
        <Route
          key={route.path}
          path={route.path}
          render={() => <route.RouteComponent filterKey={route.key || ''} savedFilters={route.filters || ''} path={route.path} />}
        />
      ))}
    </Switch>
  );
}

export default {
  RouteComponent: withRoutes(withFilters(withSideNav(Coupon))),
  module: 'coupon',
  name: 'Coupons',
  path: viewPath,
  rootPath,
  routeToTest: couponViewCheck,
};
